/**
 * Partner finder static data.
 *
 * Provides static data constants for the partner finder feature including
 * learning goals, location options, and day-of-week constants used in forms
 * and filters.
 *
 * @module partnerFinderData
 */

import { LearningGoal, Location, DayOfWeek } from '@/types/partner-finder';

/**
 * Available learning goals for partner matching.
 *
 * Used in partner request forms and filters to specify what users want to practice.
 */
export const learningGoals: LearningGoal[] = [
  { id: 'business', label: 'Business German' },
  { id: 'academic', label: 'Academic German' },
  { id: 'conversational', label: 'Conversational German' },
  { id: 'exam-prep', label: 'Exam Preparation (Goethe, TestDaF)' },
  { id: 'travel', label: 'Travel & Daily Life' },
  { id: 'literature', label: 'German Literature' },
  { id: 'other', label: 'Other' },
];

/**
 * Available location options for partner matching.
 *
 * Used in partner request forms and filters to specify preferred meeting locations.
 * Includes major German, Austrian, and Swiss cities.
 */
export const locations: Location[] = [
  { id: 'berlin', label: 'Berlin, Germany' },
  { id: 'munich', label: 'Munich, Germany' },
  { id: 'hamburg', label: 'Hamburg, Germany' },
  { id: 'frankfurt', label: 'Frankfurt, Germany' },
  { id: 'cologne', label: 'Cologne, Germany' },
  { id: 'vienna', label: 'Vienna, Austria' },
  { id: 'zurich', label: 'Zurich, Switzerland' },
];

/**
 * Array of all days of the week in order.
 *
 * Used for availability selection in partner request forms and filters.
 */
export const DAYS: DayOfWeek[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

